// /store/drive/selectors.js
import { createSelector } from "@reduxjs/toolkit";
import { isMimeTypeSupported } from "../../utils/mimeTypes";


export const selectFilteredOneDriveFiles = createSelector(
  [
    (state) => state.recentOneDrive.recentDriveFiles,
    (_, inputFileTypes) => inputFileTypes
  ],
  (files, inputFileTypes) => {
    if (!files || !files.length) return [];

    if (!inputFileTypes) return files;

    return files.filter((file) =>
      isMimeTypeSupported(file.name, inputFileTypes)
    );
  }
);
